import {
  get_pull_level,
} from "@/assets/js/my-utils.js";

import html2canvas from "html2canvas";

export function initBaiduMapCharts(chart_id, drag = false, center = [114.51666847606012, 39.25049603501119], zoom = 6) {

  let maxZoom = 8;
  if (zoom > maxZoom) {
    maxZoom = zoom
  }
  let map = new BMap.Map(chart_id, { minZoom: 6, maxZoom: maxZoom });

  // if (isMobile) {
  //   map.centerAndZoom("吕梁", 3); //取兰州作为中心点
  // } else {
  //   map.centerAndZoom("qin", 6); //取兰州作为中心点
  // } 

  if (!drag) {
    map.disableDragging();     //禁止拖拽
  }

  map.centerAndZoom(new BMap.Point(center[0], center[1]), zoom);

  // map.addControl(new BMap.NavigationControl()); // 缩放控件
  // map.addControl(new BMap.ScaleControl()); // 比例尺
  map.enableScrollWheelZoom(true);

  return map;
}

export function addCityMarker2BaiduMap(map, city, lable) {
  let myGeo = new BMap.Geocoder();
  let cityLocation;

  if (city == "莱芜") {
    city = "莱芜区";
  }
  else if (city == "东营") {
    city = "东营市";
  } else {
    city = city + "市"
  }


  // 获取到城市的坐标
  // 根据坐标得到地址描述
  var labels = lable;
  myGeo.getPoint(
    city,
    function (point) {
      if (point) {
        myGeo.getLocation(new BMap.Point(point.lng, point.lat), function (
          result
        ) {
          if (result) {
            cityLocation = new BMap.Point(
              result.point["lng"],
              result.point["lat"]
            );

            let marker = new BMap.Marker(cityLocation); // 创建标注

            marker.$city = city;
            marker.$layerType = "marker";
            marker.setLabel(labels);
            map.addOverlay(marker); // 将标注添加到地图中
            marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          }
        });
      }
    },
    "中国"
  );
}
export function drawBaiduMapCityBoundary(
  map,
  city,
  strokeColor = "rgba(0,0,0,0.1)",
  fillColor = "rgba(0,0,0,0.1)",
  fillOpacity = 0.5,
  strokeWeight = 2
) {
  var bdary = new BMap.Boundary();
  if (city == "莱芜") {
    city = "莱芜区";
  }
  else if (city == "东营") {
    city = "东营市";
  } else {
    city = city + "市"
  }

  bdary.$getCount = 1;
  drawBoundary(bdary, city);

  function drawBoundary(bdary, city) {
    if (bdary.$getCount <= 5) {
      bdary.get(city, function (rs) {
        bdary.$getCount++;
        //获取行政区域
        var count = rs.boundaries.length; //行政区域的分块可能有多少个
        if (count === 0) {
          console.log(
            city + ":未能获取当前输入行政区域",
            "第" + bdary.$getCount + "次尝试"
          );
        } else {
          var pointArray = [];
          for (var i = 0; i < count; i++) {
            let ply = new BMap.Polygon(rs.boundaries[i], {
              strokeWeight: strokeWeight,
              strokeColor: strokeColor,
              fillColor: fillColor,
              fillOpacity: fillOpacity,
            }); //建立多边形覆盖物

            if (city == "莱芜区") {
              city = "莱芜";
            }
            if (city == "东营市") {
              city = "东营";
            }
            city = city.replace("市", "")

            ply.$city = city;
            ply.$layerType = "base"; //颜色底层
            map.addOverlay(ply); //添加覆盖物
            ply.disableMassClear();

            if (!map.$ply) {
              map.$ply = [];
            }
            map.$ply.push({ ply: ply, city: city });

            pointArray = pointArray.concat(ply.getPath());
          }
        }
      });
    }
  }
}

export function getRGBColor(value, assessType, pull) {
  if (assessType == "pull") {
    // let colors = [
    //   "#00E400",
    //   "#FFFF00",
    //   "#FF7E00",
    //   "#FF0000",
    //   "#99004C",
    //   "#7E0023",
    // ];

    // let colors = [
    //   "#99FF33", "#FFFF97", "#FFFF00", "#FFDC00", "#FFB03B", "#FF9900", "#FF7E00", "#FF5B5B", "#FF0000", "#99004C", "#7E0023",
    // ];

    let colors = [
      "#00E400", "#FFDC00", "#FFB03B", "#FF7E00", "#FF5B5B", "#FF0000", "#99004C", "#7E0023", "#000000",
    ];

    return colors[get_pull_level(pull, value) - 1];
  } else {
    let visualMapTop = 20;
    if (value > 0) {
      value = value + 5;
    }
    let alpha = (Math.abs(value) * 100) / 20 > 1 ? 1 : (Math.abs(value) * 100) / 20;
    alpha = alpha < 0.1 ? 0.1 : alpha;
    let color = "";
    if (value < 0) {
      color = "rgba(65,105,225," + alpha + ")";
    } else {
      color = "rgba(255,0,0," + alpha + ")";
    }

    return color;
  }

}





//转换成图片
export function GenerateMapImgFromDom(canvas, filename) {
  // let canvas = document.querySelector(".canvasImgObj"); //先获取要截取页面的DOM
  let that = this;
  html2canvas(canvas, {
    scale: window.devicePixelRatio || 1,
    logging: false,
    useCORS: true,
  }).then(function (canvas) {

    // 生成图片
    let type = "png";
    let imgData = canvas.toDataURL(type);
    // 照片格式处理
    let _fixType = function (type) {
      type = type.toLowerCase().replace(/jpg/i, "jpeg");
      let r = type.match(/png|jpeg|bmp|gif/)[0];
      return "image/" + r;
    };
    imgData = imgData.replace(_fixType(type), "image/octet-stream");
    // let filename = "设备地图" + "." + type;
    saveFile(imgData, filename);
  });
}

export function GenerateImgFromChart(charts, filename) {
  let content = charts.getDataURL();
  let blob = base64ToBlob(content);
  let url_data = window.URL.createObjectURL(blob);
  saveFile(url_data, filename);
}

function base64ToBlob(code) {
  let parts = code.split(';base64,');
  let contentType = parts[0].split(':')[1];
  let raw = window.atob(parts[1]);
  let rawLength = raw.length;

  let uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
}

//下载至本地
export function saveFile(data, filename) {

  let anchor = document.createElement("a");
  anchor.href = data;
  anchor.download = filename;
  anchor.click();

  // document.removeChild(anchor);
}
